import {CONFIG} from 'src/config';
import { store } from '../store'
import {assertFunction} from "@babel/core/lib/config/validation/option-assertions";
//import Swal from "sweetalert2";

const showGenericAlert = (msg, detail, typeClass) => {

    if (window.globalAlert) {
        window.globalAlert.remove();
    }

    if (!detail) detail = "";
    let iconClass = "";

    if (typeClass === 'success') {
        iconClass = "fa fa-check-circle";
    }
    else if (typeClass === 'error') {
        iconClass = "fa fa-times-circle";
    }
    else if (typeClass === 'info') {
        iconClass = "fa fa-info-circle";
    }
    else if (typeClass === 'warning') {
        iconClass = "fa fa-warning";
    }

    const title = document.createElement('div');
    title.innerHTML = "<i class='"+iconClass+" mr-2'></i>" + msg;
    title.className = 'titleA';
    const msgDiv = document.createElement('div');
    msgDiv.innerHTML = detail;
    msgDiv.className = 'msgA';

    const globalAlert = document.createElement('div');
    globalAlert.className = "globalAlert " + typeClass;
    globalAlert.appendChild(title);
    globalAlert.appendChild(msgDiv);
    document.body.appendChild(globalAlert);
    window.globalAlert = globalAlert;

    setTimeout(function () {
        globalAlert.style.opacity = '100';
    }, 50);

    const deleteEvent = setTimeout(function () {
        globalAlert.style.opacity = '0';
        setTimeout(function () {
            globalAlert.remove();
        }, 5500);
    }, 5000);

    globalAlert.addEventListener('click',function () {
        globalAlert.remove();
        clearTimeout(deleteEvent);
    })
}

const showGenericNotify = (msg, detail, typeClass, isConfirm, callbackConfirm, callbackCancel, btnConfirmText, btnCancelText) => {

    if (!isConfirm) isConfirm = false;
    if (!detail) detail = "";
    if (!callbackConfirm) callbackConfirm = false;
    if (!callbackCancel) callbackCancel = false;
    if (!btnConfirmText) btnConfirmText = "Continuar";
    if (!btnCancelText) btnCancelText = "Cancelar";

    let iconClass = "";

    if (typeClass === 'success') {
        iconClass = "fa fa-check-circle";
    }
    else if (typeClass === 'error') {
        iconClass = "fa fa-times-circle";
    }
    else if (typeClass === 'info') {
        iconClass = "fa fa-info-circle";
    }
    else if (typeClass === 'warning') {
        iconClass = "fa fa-warning";
    }

    const title = document.createElement('div');
    title.innerHTML = "<i class='"+iconClass+" mr-2'></i>" + msg;
    title.className = 'titleA';
    const msgDiv = document.createElement('div');
    msgDiv.innerHTML = detail;
    msgDiv.className = 'msgA';

    const continueBtn = document.createElement('button');
    continueBtn.className = "continueBtn";
    continueBtn.innerHTML = btnConfirmText;
    continueBtn.addEventListener("click", function () {
        if (isConfirm) {
            if (typeof callbackConfirm === 'function') {
                callbackConfirm();
            }
            globalAlert.remove();
        }
        else {
            globalAlert.remove();
        }
    })

    const cancelBtn = document.createElement('button');
    cancelBtn.className = "cancelBtn";
    cancelBtn.innerHTML = btnCancelText;
    cancelBtn.addEventListener("click", function () {
        if (isConfirm) {
            if (typeof callbackCancel === 'function') {
                callbackCancel();
                globalAlert.remove();
            }
            else {
                globalAlert.remove();
            }
        }
        else {
            globalAlert.remove();
        }
    })

    const globalAlertContainer = document.createElement('div');
    globalAlertContainer.appendChild(title);
    globalAlertContainer.appendChild(msgDiv);
    globalAlertContainer.appendChild(continueBtn);

    if (isConfirm) {
        globalAlertContainer.appendChild(cancelBtn);
    }

    const globalAlert = document.createElement('div');
    globalAlert.className = "globalNotify " + typeClass;
    globalAlert.appendChild(globalAlertContainer);
    document.body.appendChild(globalAlert);

    setTimeout(function () {
        globalAlert.style.opacity = '100';
    }, 50);
}

export default {
    send: (method, url, data, onSuccess, onError, options) => {

        if (!method) method = 'GET';
        method = method.toUpperCase();

        if (!options) options = {};

        if (!options.disableLoading) {
            // voy a validar si el token esta ok
            store.dispatch('coreShowLoading');
        }

        const config = {
            method: method,
        };

        if (method === 'FILE') {
            config['headers'] = new Headers({
                'Authorization': 'Bearer ' + store.getters.AuthGetToken,
                "X-Any-Wl": (store.getters.whiteLabelInfo) ? store.getters.whiteLabelInfo.id : 0,
            });
            config.method = 'POST';
            config['body'] = data;
        }
        else {
            config['headers'] = new Headers({
                'Authorization': 'Bearer ' + store.getters.AuthGetToken,
                "Content-Type": "application/json",
                "X-Any-Wl": (store.getters.whiteLabelInfo) ? store.getters.whiteLabelInfo.id : 0,
            });

            if (method !== 'GET') {
                config['body'] = JSON.stringify(data);
            }
        }

        fetch(CONFIG.getWsUrl(url), config)
            .then(response => response.json())
            .then(data => {
                if (typeof data.status !== 'undefined') {
                    if (data.status) {
                        onSuccess(data);
                        if (!options.disableLoading && !store.getters.coreIsLockedLoading) {
                            store.dispatch('coreHideLoading');
                        }
                    }
                    else {
                        if (!options.disableLoading && !store.getters.coreIsLockedLoading) {
                            store.dispatch('coreHideLoading');
                        }

                        if (data['error-code'] === 'RT-NO-ACCESS') {
                            showGenericAlert("El usuario requiere acceso al módulo: " + data['data']['m'], '', 'error');
                        }
                        else {
                            onError(data);
                        }
                    }
                }
            })
            .catch((e) => {
                console.log('API-RequestError:'+ e);
                if (!options.disableLoading) {
                    store.dispatch('coreHideLoading');
                }
                showGenericAlert("Ha ocurrido un error, por favor intente de nuevo", '', 'error');
            });
    },
    showSuccessAlert : (msg, detail) => {
        if (!detail) detail = "";
        showGenericAlert(msg, detail, 'success');
    },
    showErrorAlert : (msg, detail) => {
        if (!detail) detail = "";
        showGenericAlert(msg, detail, 'error');
    },
    showInfoAlert : (msg, detail) => {
        if (!detail) detail = "";
        showGenericAlert(msg, detail, 'info');
    },
    showWarningAlert : (msg, detail) => {
        if (!detail) detail = "";
        showGenericAlert(msg, detail, 'warning');
    },
    showFormValidationErrors : (errors) => {
        let strError = '';
        for (let error of errors) {
            strError += error + ', ';
        }
        strError = strError.replace(/,\s*$/, "");
        showGenericAlert("Error al llenar campos", strError, 'error');
    },
    showSuccessNotify: (title, msg) => {
        showGenericNotify(title, msg, 'success');
    },
    showErrorNotify: (title, msg) => {
        showGenericNotify(title, msg, 'error');
    },
    showConfirm: (title, msg, callbackOnSuccess, callbackOnCancel, btnContinueText, btnCancelText) => {
        showGenericNotify(title, msg, 'info', true, callbackOnSuccess, callbackOnCancel, btnContinueText, btnCancelText);
    },

    // Websockets, notificador estándar
    websocket: function (channel, token, onMessageCallback, onErrorCallback) {
        if (!channel) channel = 'standard';
        if (!onMessageCallback) onMessageCallback = false;
        if (!onErrorCallback) onErrorCallback = false;

        let ws = false;

        const conectar = function () {

            //const url = `ws://127.0.0.1:8888/standard_notifier`;
            const url = `wss://sockethub.paygateway-api.com/standard_notifier`;
            ws = new WebSocket(url);

            // Manejar el evento de apertura de conexión
            ws.onopen = () => {
                console.log("%cConexión WebSocket establecida 👌", "background: green; color: white; padding: 4px;");

                // Enviar mensaje de autenticación al abrir la conexión
                const authMessage = {
                    action: "authenticate",
                    channel: channel,
                    token: token,
                };
                ws.send(JSON.stringify(authMessage));
            };

            // Manejar mensajes recibidos del servidor
            ws.onmessage = (event) => {
                const self = this;
                const data = JSON.parse(event.data);

                if (data.status === "authenticated") {
                    console.log("%cSe autenticó correctamente a WebSocket ✅", "background: green; color: white; padding: 4px;");
                }
                else {
                    if (data.action === "update") {
                        if (typeof onMessageCallback === 'function') {
                            console.log("%cMensaje recibido WebSocket ✅", "background: green; color: white; padding: 4px;");
                            onMessageCallback(data);
                        }
                    }
                    else {
                        if (data.status === "error") {
                            console.error("%c" + data.message, "background: red; color: white; padding: 4px;");
                            if (typeof onErrorCallback === 'function') {
                                onErrorCallback(data);
                            }
                        }
                    }
                }
            };

            // Manejar el evento de cierre de conexión
            ws.onclose = (event) => {
                ws.close(); // lo tenemos que cerrar porque si no, los eventos se quedan amarrados
                console.log("%cConexión WebSocket cerrada por exceso de tiempo de espera.", "background: orange; color: white; padding: 4px;");
                setTimeout(function() {
                    conectar();
                }, 4000);
            };

            // Manejar errores de WebSocket
            ws.onerror = (error) => {
                ws.close(); // lo tenemos que cerrar porque si no, los eventos se quedan amarrados
                console.error("%cError en el WebSocket, intentando reconectar: " + error, "background: red; color: white; padding: 4px;");
            };
        }


        // conectamos
        conectar();

        this.sendMessage = function(data) {

            // Preparar los datos de la ficha médica actualizada
            const messageSend = {
                action: "update",
                channel: channel,
                data: data,

            };
            // Enviar la actualización al servidor WebSocket
            if (ws && ws.readyState === WebSocket.OPEN) {
                ws.send(JSON.stringify(messageSend));
            }
            else {
                console.error("%cConexión WebSocket no está abierta", "background: orange; color: white; padding: 4px;");
            }
        }

    },
}
